import * as yup from 'yup'

const schema = yup.object().shape({
  email: yup.string().email().required(),
  companySupplierQuestionnaires: yup.array().of(yup.object()).required(),
})

export default schema
